export default function () {
    for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
        for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
            if (node = group[i]) {
                if (next && node.compareDocumentPosition(next) ^ 4)
                    next.parentNode.insertBefore(node, next);
                next = node;
            }
        }
    }
    return this;
}
